import { render, staticRenderFns } from "./PackageBuffet.vue?vue&type=template&id=8360b8f4"
import script from "./PackageBuffet.vue?vue&type=script&lang=js"
export * from "./PackageBuffet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports